import { render, staticRenderFns } from "./addressManage.vue?vue&type=template&id=db712bf8&scoped=true"
import script from "./addressManage.vue?vue&type=script&lang=js"
export * from "./addressManage.vue?vue&type=script&lang=js"
import style0 from "./addressManage.vue?vue&type=style&index=0&id=db712bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db712bf8",
  null
  
)

export default component.exports